define(['jquery', 'cookies', 'settings', 'erv_popup', 'erv_checks', 'userway_helpers'], function ($, Cookies, Settings, Popup, ERVChecks, UserwayHelpers) {

	var ERVFramework = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.cookies = Cookies;
		self.settings = Settings;
		self.userwayHelpers = UserwayHelpers;
		self.popup = new Popup();
		self.checks = new ERVChecks();
		self.neverExpires = 10 * 365;
	};

	ERVFramework.prototype.initTooltips = function (selector) {
		var self = this;
        $(selector).tooltip({
            position: {
                my: "center bottom-5",
                at: "center top",
                using: function(position, feedback) {
					var userWayLineHeightEnabled = $("[data-userway-s17-styled=\"true\"").length;
					if (userWayLineHeightEnabled) {
						var level = +$("[data-userway-s17-styled=\"true\"").attr('data-line-height-feature-value');
						position.top = position.top - (level + 1)*30;
					}

                    $(this).css(position);

                    // Adjust position based on zoom level
                    var zoomContainer = document.querySelector('#erv-body');
                    if (zoomContainer) {
						var tooltip = this;
						setTimeout(function() {
							self.userwayHelpers.repositionElementTopRelativeToInput(feedback.target.element[0], tooltip, zoomContainer, {gap: 20});
						}, 200);
                    }

					//only add for touch devices
					if ($(this).find('p.block').length === 0 && (('ontouchstart' in window) || !!(navigator.msMaxTouchPoints))) {
						var $closeContainer = $('<p>');

						var $closeLink = $("<a class=\"close-link\" href=\"javascript:$('" + selector + "').tooltip('close');\">").html('&#10006;');
						$closeLink.appendTo($closeContainer);

						$closeContainer.prependTo(this);
					}
				}
			},
            show: { duration: 200 },
			 /**
             * For clarification: https://api.jqueryui.com/tooltip/#option-classes
             */
            classes: {
                "ui-tooltip": "ui-corner-all"
            }
        });

		$(selector).on('click', function (e) {
			e.stopPropagation();
			e.preventDefault();
			if ($('.ui-tooltip').length > 0) {
				$(selector).tooltip('close');
			}
			$(this).tooltip('open');
		});

		$(window).on('resize scroll',
			function () {
				setTimeout(function () {
					if ($('.ui-tooltip').length > 0) {
						$(selector).tooltip('close');
					}
				}, 100);
			});

		$('.ui-tooltip').on('touchstart click',
			function () {
				if ($('.ui-tooltip').length > 0) {
					$(selector).tooltip('close');
				}
			});

		$('body').on('click',
			function () {
				if ($('.ui-tooltip').length > 0) {
					$(selector).tooltip('close');
				}
			});
	};

    ERVFramework.prototype.initPreferredSiteSection = function () {
		var self = this,
			$sectionLinksLists = self.$ervBody.find('.section-links'),
			cookieName = self.settings.CookieStrings.PreferredSection,
			firstLink = '';

		$sectionLinksLists.each(function () {
			var $list = $(this);
			var $links = $list.find('a');

			$links.each(function () {
				var $link = $(this);

				if (firstLink === '') {
					firstLink = $link.attr('href');
				}

				$link.on('click',
					function () {
						var href = $(this).attr('href');
						var a = $('<a>', { href: href })[0]; //trick
						if (a.hostname !== window.location.hostname) {
							self.cookies.set(cookieName, firstLink, { expires: self.neverExpires, path: '/' });
						} else {
							self.cookies.set(cookieName, href, { expires: self.neverExpires, path: '/' });
						}
					});
			});
		});
	};

	ERVFramework.prototype.initGenericAlert = function (errorMessage, settings) {
		var self = this,
			$lightbox = $('body').find('#generic-alert-lightbox'),
			$button = $lightbox.find('[data-js="ok"]');

		if (!$lightbox || !$lightbox.length || !$button || !$button.length) {
			alert(errorMessage);

			if (typeof (settings) !== 'undefined' && typeof (settings.callback) === 'function') {
				settings.callback();
			}
			return;
		}

		self.popup.openPopup(
			'#generic-alert-lightbox',
			{
				elementParse: function (item) {
					$(item.src).removeClass('hide');
				}
			},
			true, true
		);

		var $additionalInformation = $lightbox.find('[data-js="additional-information"]'),
			$serverErrorMessage = $additionalInformation.find('[data-js="serverside-message"]');

		if (errorMessage != undefined && errorMessage.length > 0) {
			$additionalInformation.removeClass('hide');
			$serverErrorMessage.text(errorMessage);
		} else {
			$additionalInformation.addClass('hide');
		}

		if (typeof (settings) !== 'undefined') {
			var $mainInformation = $lightbox.find('[data-js="main-information"]');

			if (typeof (settings.heading) !== 'undefined') {
				var $heading = $mainInformation.find('h2');
				$heading.text(settings.heading);
			}

			if (typeof (settings.hideMainDescription) !== 'undefined') {
				var $description = $mainInformation.find('p');
				$description.addClass('hide');
			}
		}

		$button.on('click', function (e) {
			e.preventDefault();
			$.magnificPopup.close();
			if (typeof (settings) !== 'undefined' && typeof (settings.callback) === 'function') {
				settings.callback();
			}
		});
	}

	var equalizeTeasersTimeoutId = null;
	ERVFramework.prototype.equalizeTeasers = function (overrideSelector, wait) {
		var delay = wait != undefined ? wait : 300;

		if (equalizeTeasersTimeoutId != null) {
			clearTimeout(equalizeTeasersTimeoutId);
			equalizeTeasersTimeoutId = null;
		}

		var $containers = $((typeof (overrideSelector) === 'undefined' || overrideSelector.length === 0) ? '.teaser-container' : overrideSelector);

		if ($containers.length === 0) { return false; }

		//iconblock fix
		var $teasers = $containers.find('.box, .icon-block, .teaser-block');
		$teasers.addClass('no-hover');

		equalizeTeasersTimeoutId = setTimeout(function () {
			var	$images = $containers.find('.top-image[data-js="equalizethis"]'),
				$contents = $containers.find('.content[data-js="equalizethis"]'),
				$pricings = $containers.find('.pricing[data-js="equalizethis"]');


			if ($images.length > 0) {
				$images.matchHeight({
					byRow: true
				});
			}

			if ($contents.length > 0) {
				$contents.matchHeight({
					byRow: true
				});
			}

			if ($pricings.length > 0) {
				$pricings.matchHeight({
					byRow: true
				});
			}

			$teasers.removeClass('no-hover');

			equalizeTeasersTimeoutId = null;
		}, delay);
	}

	ERVFramework.prototype.equalizeParent = function ($children) {
		if (!$children.length) {
			return false;
		}

		var max = 0,
			$parent = $children.parent();

		$parent.addClass('no-hover');

		$children.each(function () {
			var height = $(this).height();
			max = height > max ? height : max;
		});

		$parent.css('height', max);

		$parent.removeClass('no-hover');
	}

	return ERVFramework;
});